/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { openTransactionDetailsDialogAction } from '@root/entities/transaction/atoms'
import { TransactionHistoryList } from '@root/features/user'
import { ProfileOwner } from '@root/features/user/profile/model/profile-owner'
import { reatomUserTransactions } from '@root/features/user/transaction-history'
import { TransactionHistoryListEmpty } from '@root/features/user/transaction-history/ui/transaction-history-list-empty'

import type { DelugeId } from '@root/entities/user-short'

export const ProfileBoardTransactions = (props: {
  delugeId?: DelugeId
  profileOwner: ProfileOwner
}) => {
  const [network] = useAtom(selectedNetworkAtom)
  const transactionsStateAtom = useMemo(
    () =>
      reatomUserTransactions({
        delugeId: props.delugeId,
        network,
        pairAddress: undefined,
      }),
    [network, props.delugeId],
  )
  const [historyState] = useAtom(transactionsStateAtom)
  const noTransactions = AsyncStateN.matchWaiting(historyState, {
    Success: (items) => items.data.length === 0,
    Error: () => true,
    Waiting: () => false,
  })

  const openTransactionDetailsDialog = useAction(
    openTransactionDetailsDialogAction,
  )

  return (
    <Root data-empty={noTransactions}>
      <TransactionHistoryList
        withWallet
        delugeId={props.delugeId}
        onOpenTransactionDetails={openTransactionDetailsDialog}
        model={transactionsStateAtom}
        renderEmptyMessage={() => (
          <TransactionHistoryListEmpty
            transactionsOwner={
              props.profileOwner === ProfileOwner.CurrentUser
                ? 'current'
                : 'another'
            }
            infoVariant="bold"
            withRetry
            withBackground
          />
        )}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  position: relative;
  overflow: auto;

  height: 100%;
  padding: 6px;

  &[data-empty='true'] {
    padding: 6px;
  }
`
